import {
  ApiResponse,
  ReferralProgramConfig,
  ReferralDashboardResponse,
  StaffReferralListResponse,
  QualificationLogsResponse,
  QualificationRunDetailResponse,
  ReferralConfigAuditResponse,
  UpdateReferralConfigRequest,
  ForceQualifyResponse,
  MessageResponse,
} from '@mygate/common';
import { api } from './api';

function buildQueryString(params?: Record<string, string | number | undefined>): string {
  if (!params) return '';
  const queryParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined) {
      queryParams.append(key, String(value));
    }
  });
  const queryString = queryParams.toString();
  return queryString ? `?${queryString}` : '';
}

class ReferralsService {
  async getConfig(): Promise<ApiResponse<ReferralProgramConfig>> {
    return api.get('/api/staff/referrals/config');
  }

  async updateConfig(data: UpdateReferralConfigRequest): Promise<ApiResponse<ReferralProgramConfig>> {
    return api.put('/api/staff/referrals/config', data);
  }

  async getDashboard(): Promise<ApiResponse<ReferralDashboardResponse>> {
    return api.get('/api/staff/referrals/dashboard');
  }

  async getList(params?: {
    page?: number;
    limit?: number;
    status?: string;
  }): Promise<ApiResponse<StaffReferralListResponse>> {
    return api.get(`/api/staff/referrals/list${buildQueryString(params)}`);
  }

  async rejectReferral(id: string, reason?: string): Promise<ApiResponse<MessageResponse>> {
    return api.post(`/api/staff/referrals/${id}/reject`, { reason });
  }

  async retryDistribution(id: string): Promise<ApiResponse<MessageResponse>> {
    return api.post(`/api/staff/referrals/${id}/retry`);
  }

  async forceQualify(id: string, reason?: string): Promise<ApiResponse<ForceQualifyResponse>> {
    return api.post(`/api/staff/referrals/${id}/force-qualify`, { reason });
  }

  async getConfigAudit(): Promise<ApiResponse<ReferralConfigAuditResponse>> {
    return api.get('/api/staff/referrals/config/audit');
  }

  async getQualificationLogs(params?: {
    page?: number;
    limit?: number;
  }): Promise<ApiResponse<QualificationLogsResponse>> {
    return api.get(`/api/staff/referrals/logs${buildQueryString(params)}`);
  }

  async getRunLogs(runId: string): Promise<ApiResponse<QualificationRunDetailResponse>> {
    return api.get(`/api/staff/referrals/logs/${encodeURIComponent(runId)}`);
  }
}

export const referralsService = new ReferralsService();
